function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9992 0C17.9426 0 0 17.944 0 40C0 62.056 17.9426 80 39.9992 80C62.0558 80 80 62.056 80 40C80 17.944 62.0558 0 39.9992 0ZM39.9992 74.754C20.836 74.754 5.246 59.1632 5.246 40C5.246 20.8366 20.8358 5.2462 39.9992 5.2462C59.1626 5.2462 74.7534 20.8368 74.7534 40C74.7536 59.1632 59.1624 74.754 39.9992 74.754Z",
  fill: "#1EDEB0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.4835 26.9063L33.8573 47.5315L25.5195 39.1955C24.4949 38.1721 22.8351 38.1715 21.8105 39.1961C20.7855 40.2211 20.7855 41.8811 21.8105 42.9057L32.0031 53.0967C32.5153 53.6083 33.1863 53.8643 33.8573 53.8643C34.5283 53.8643 35.2011 53.6083 35.7131 53.0959C35.7147 53.0937 35.7159 53.0915 35.7185 53.0889L58.1923 30.6153C59.2173 29.5913 59.2173 27.9301 58.1923 26.9061C57.1679 25.8815 55.5069 25.8815 54.4835 26.9063Z",
  fill: "#1EDEB0"
});

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.dec250bf.svg";
export { ForwardRef as ReactComponent };